var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineRefreshRightSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 12.26c0-3.17 2.58-5.75 5.75-5.75.64 0 1.28.09 1.89.28.4.12.62.54.5.94a.75.75 0 0 1-.94.5c-.46-.14-.95-.21-1.45-.21a4.26 4.26 0 0 0-4.25 4.25A4.26 4.26 0 0 0 12 16.52a4.26 4.26 0 0 0 4.25-4.25c0-.85-.25-1.66-.71-2.36a.746.746 0 0 1 .21-1.04c.34-.23.81-.14 1.04.21.63.95.97 2.05.97 3.19A5.764 5.764 0 0 1 12 18.01c-3.17 0-5.75-2.58-5.75-5.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.811 8.14-1.67-1.91a.756.756 0 0 1 .07-1.06c.31-.27.79-.24 1.06.07l1.67 1.91c.27.31.24.79-.07 1.06-.14.13-.31.19-.49.19-.21 0-.42-.09-.57-.26z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.83 9.51c-.24-.33-.17-.8.16-1.05l1.94-1.42c.33-.24.8-.17 1.05.16.24.33.17.8-.16 1.05l-1.94 1.42c-.13.1-.29.15-.44.15-.23 0-.46-.11-.61-.31z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineRefreshRightSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-refresh-right-square.b5713d3067b88f47ca6a6d84e862c8fa.svg";
export { ForwardRef as ReactComponent };